import Link from 'next/link';

import CloudinaryImage from '../common/CloudinaryImage';

export default function PlatformList({ platformlist }) {
  return (
    <div className="mb-[5px] border border-[#0050D521] bg-[#FAFCFF] rounded-[4px] p-4">
      {platformlist?.PlatformsList.length !== 0 && (
        <>
          <h5 className="md:text-[22px] text-[18px] text-[#2B2B2D] font-[700] mb-5 block">
            {platformlist?.ListenPlatformText}
            <span className="border border-[#FFA030] block w-[50px]"></span>
          </h5>
          <ul>
            {platformlist?.PlatformsList?.map(img => (
              <li key={img?.id} className="mb-4">
                <Link href={`${img?.link ? img?.link : ''}`}>
                  <CloudinaryImage
                    backendImgUrl={img?.image?.data?.attributes?.url}
                    alt={img?.image?.data?.attributes?.alternativeText}
                    className="w-[140px]"
                    type={'icon'}
                  />
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
      {platformlist?.ListenList.length !== 0 && (
        <>
          <h5 className="md:text-[22px] text-[18px] text-[#2B2B2D] font-[700] mb-5 block mt-10">
            {platformlist?.WayListenText}
            <span className="border border-[#FFA030] block w-[50px]"></span>
          </h5>

          <ul>
            {platformlist?.ListenList?.map(img => (
              <li key={img?.id} className="mb-4">
                <Link href={`${img?.link ? img?.link : ''}`}>
                  <CloudinaryImage
                    backendImgUrl={img?.image?.data?.attributes?.url}
                    alt={img?.image?.data?.attributes?.alternativeText}
                    className="w-[140px]"
                    type={'icon'}
                  />
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
